export default function shouldOpenInNewTab(openInNewTab) {
  return openInNewTab
    ? {
        target: '_blank',
        rel: 'noopener noreferrer',
      }
    : {}
}
